<template>
	<b-container>
		<b-form @submit.prevent>
			<b-row class="mt-3">
				<b-col cols="12">
					<h1>{{ job.Id }} -

									<b-link				
				title="Go to clock"
				:to="{
					name: 'clockupdate',
					params: { id: job.Clock.Id },
				}"
				>{{ job.Clock.Name }}</b-link
			>

					</h1>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col>
					<b-link class="float-right ml-3" @click.prevent="deleteJob" title="Delete this job">
						<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
					</b-link>
					<save-or-edit-buttons :editable="editable.details" :creating="creating" section="details" @save="saveSection" @edit="editSection"></save-or-edit-buttons>
				</b-col>
			</b-row>

			<b-row class="mt-3" v-if="editable.details">
				<b-col cols="3">
					<b-form-group label="Type" for="jobtype">
						<b-form-select id="job-type" v-model="job.Type" value-field="Value" text-field="DisplayName" :options="jobTypes"></b-form-select>
					</b-form-group>
				</b-col>

				<b-col cols="3">
					<b-form-group label="Status" for="jobstatus">
						<b-form-select id="jobstatus" v-model="job.JobStatusId" value-field="Id" text-field="Name" :options="states"></b-form-select>
					</b-form-group>
				</b-col>

				<b-col cols="3">
					<b-form-group label="PO Number" for="ponumber">
						<b-input-group>
							<b-form-input id="ponumber" v-model="job.PONumber" maxlength="50" /><b-input-group-append is-text>
								<document-asset :asset="job.PurchaseOrderFile" :relate="job.Id" type="0" folder="Job" direction="up" />
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</b-col>

				
			</b-row>
			<b-row v-else class="mt-3 mb-3">
				<b-col class="d-flex justify-content-start">
					<h2 class="p-2">
						{{ jobTypeName }} | {{ jobStatusName }} |
						{{ job.PONumber }}
					</h2>

					<document-asset :asset="job.PurchaseOrderFile" :relate="job.Id" type="0" folder="Job" direction="down" />
				</b-col>
			</b-row>

			<b-tabs content-class="mt-3">
				<b-tab title="Details" active>
					<b-row class="mt-3">
						<b-col cols="10" class="mt-3 mb-3">
							<h4>Job Details</h4>
						</b-col>

						<b-col cols="12">
							<b-card no-body bg-variant="light">
								<b-card-body>
									<save-or-edit-buttons :editable="editable.description" section="description" @save="saveSection" @edit="editSection"></save-or-edit-buttons>

									<b-card-title>Description</b-card-title>

									<b-card-text v-if="editable.description">
										
										<b-form-textarea id="textarea" v-model="job.Details" placeholder="Enter something..." rows="12" max-rows="12"></b-form-textarea>

										
										<b-form-checkbox :value="true" v-model="job.Rope">Rope job?</b-form-checkbox>
									
									</b-card-text>

									<b-card-text v-else>
										<p>{{ job.Details }}</p>

										<p>Rope job: {{ job.Rope == true ?  '✔' : '❌' }}</p>
									</b-card-text>
								</b-card-body>
							</b-card>
						</b-col>

						<b-col cols="12" class="mt-3 mb-3">
							<b-card bg-variant="light" title="Enquiry by">
								<b-link class="float-right" title="Change job contact" @click.prevent="changeContactClick">
									<b-icon font-scale="1.5" icon="pencil-square"></b-icon>
								</b-link>

								<b-card-text class="d-flex justify-content-start">
									<b-link class="p-2" href="#" @click.prevent="editContact(job.Contact.Id, null)">{{ job.Contact.Name }}</b-link>
									<span class="p-2">{{ job.Contact.Telephone }}</span>
									<span class="p-2">{{ job.Contact.EmailAddress }}</span>
								</b-card-text>
							</b-card>
						</b-col>

						<b-col cols="12">
							<b-card no-body bg-variant="light">
								<b-card-body>
									<save-or-edit-buttons :editable="editable.invoicenumbers" section="invoicenumbers" @save="saveSection" @edit="editSection"></save-or-edit-buttons>

									<b-card-title>Invoice numbers</b-card-title>

									<b-card-text v-if="editable.invoicenumbers">
										
										<b-col cols="3">
											<b-form-group label="Invoice Number" for="invoicenumber">
												<b-form-input id="invoicenumber" v-model="job.InvoiceNumber" maxlength="60" />
											</b-form-group>

											<b-form-group label="Part Invoice Number" for="partinvoicenumber">
												<b-form-input id="partinvoicenumber" v-model="job.PartInvoiceNumber" maxlength="60" />
											</b-form-group>
										</b-col>

									</b-card-text>

									<b-card-text v-else>
										<p>Invoice number: {{ job.InvoiceNumber }}</p>

										<p>Part Invoice number: {{ job.PartInvoiceNumber }}</p>
									</b-card-text>


								</b-card-body>
							</b-card>
						</b-col>
						
					</b-row>
				</b-tab>

				<b-tab title="Quotes">
					<b-row class="mt-3">
						<b-col cols="10" class="mt-3 mb-3">
							<h4>Quotes</h4>
						</b-col>

						<b-col cols="2">
							<b-link @click.prevent="quoteCreate" class="float-right mb-3" title="Create Quote">
								<b-icon font-scale="1.5" icon="plus-square"></b-icon>
							</b-link>
						</b-col>
					</b-row>

					<b-row v-if="job.Quotes.length">
						<b-col cols="12" class="mb-1" v-for="(quote, index) in job.Quotes" :key="index + 10">
							<b-card bg-variant="light">
								<b-card-text class="d-flex justify-content-start">
									<b-link
										class="p-2"
										:to="{
											name: 'quoteupdate',
											params: {
												id: job.Id,
												quote: quote.Id
											}
										}"
										>{{ quote.Reference }} Revision:
										{{ quote.Revision }}
									</b-link>

									<span class="p-2">{{ mailStatusName(quote.Mail) }}</span>

									<span class="p-2" v-if="quote.Mail == 1">({{ formatDate(quote.Sent) }})</span>

									<span class="p-2" v-if="quote.Status > 0">{{ quoteStatusName(quote.Status) }}</span>

									<span class="p-2">
										<b-link
											v-if="quote.Mail == 1 && quote.Status == 2"
											title="Make a revision of this quote"
											class="float-right"
											:to="{
												name: 'quoteupdate',
												params: {
													id: job.Id,
													quote: quote.Id,
													revision: true
												}
											}"
										>
											<b-icon font-scale="1.5" icon="arrow-clockwise"></b-icon>
										</b-link>
									</span>
								</b-card-text>
							</b-card>
						</b-col>
					</b-row>

					<b-row v-else class="mt-3">
						<b-col>
							<h4>There are no quotes yet</h4>
						</b-col>
					</b-row>
				</b-tab>

				<b-tab title="Tasks">
					<b-row class="mt-3">
						<b-col cols="10" class="mt-3 mb-3">
							<h4>Tasks</h4>
						</b-col>
					</b-row>

					<div v-if="job.Assignments.length">
						<job-task-list :jobId="job.Id" :assignments="job.Assignments" @updateJobTasks="updateTasks" @handleError="handleError" />
					</div>
					<div v-else>
						<job-task-list-empty :jobId="job.Id" @updateJobTasks="updateTasks" @handleError="handleError" />
					</div>
				</b-tab>

				<b-tab title="Log">
					<b-row class="mt-3">
						<b-col cols="10" class="mt-3 mb-3">
							<h4>Notes</h4>
						</b-col>

						<b-col cols="2">
							<b-link
								class="float-right mb-3"
								title="Add a note"
								v-b-modal.sharedModal
								@click.prevent="
									modalContent = 'note';
									modalTitle = 'Add note';
								"
							>
								<b-icon font-scale="1.5" icon="plus-square"></b-icon>
							</b-link>
						</b-col>
					</b-row>

					<b-form-fieldset>
						<b-table-simple bordered>
							<b-thead head-variant="light">
								<tr>
									<th>Date</th>
									<th>Person</th>
									<th>Change</th>
								</tr>
							</b-thead>

							<b-tbody>
								<tr v-for="(log, index) in logs" :key="index + 10">
									<td>{{ formatDate(log.Added) }}</td>

									<td>{{ log.FullName }}</td>
									<td>{{ log.Note }}</td>
								</tr>
							</b-tbody>
						</b-table-simple>
					</b-form-fieldset>
				</b-tab>
			</b-tabs>
		</b-form>

		<b-modal id="sharedModal" ref="sharedModal" :title="modalTitle" hide-footer>
			<add-note v-if="modalContent == 'note'" @addNote="addNote" entityType="Job" :entityId="job.Id" />

			<edit-contact v-if="modalContent == 'edit-contact'" @updateContact="updateContact" :editing="editing" />

			<change-contact v-if="modalContent == 'change-contact'" :contacts="contacts" @changeContact="changeContact" />
		</b-modal>

		<confirm ref="confirm"></confirm>
	</b-container>
</template>

<script>
import JobService from '@/api-services/job.service';
import LogService from '@/api-services/log.service';
import ContactService from '@/api-services/contact.service';
import QuoteService from '@/api-services/quote.service';
import DocumentAsset from '@/components/partials/document-asset';
import ChangeContact from '@/components/partials/change-contact';
import EditContact from '@/components/partials/edit-contact';
import SaveOrEditButtons from '@/components/partials/save-or-edit-buttons';
import AddNote from '@/components/partials/add-note';
import JobTaskList from '@/components/job/job-task-list';
import JobTaskListEmpty from '@/components/job/job-task-list-empty';

import Confirm from '@/components/partials/confirm';

import { dateFuncs } from '@/globs.js';

export default {
	name: 'jobUpdate',

	components: {
		SaveOrEditButtons,
		AddNote,
		ChangeContact,
		EditContact,
		Confirm,
		JobTaskList,
		DocumentAsset,
		JobTaskListEmpty
	},

	computed: {
		jobTypeName() {
			return this.jobTypes
				.filter((q) => q.Value == this.job.Type)
				.map(function (obj) {
					return obj.DisplayName;
				})
				.join();
		},

		jobStatusName() {
			return this.states
				.filter((q) => q.Id == this.job.JobStatusId)
				.map(function (obj) {
					return obj.Name;
				})
				.join();
		}
	},

	data() {
		return {
			job: {
				Clock: {},
				Contact: {},
				Status: {},
				Quotes: [],
				Assignments: []
			},

			logs: [],

			jobTypes: [],

			states: [],

			contacts: [],

			quoteStates: [
				{ Id: 0, Name: 'Created' },
				{ Id: 1, Name: 'Accepted' },
				{ Id: 2, Name: 'Declined' }
			],

			mailStates: [
				{ Id: 0, Name: 'Pending' },
				{ Id: 1, Name: 'Sent' }
			],

			editing: {
				id: null,
				index: null
			},

			modalContent: null,
			modalTitle: 'Select',

			creating: false,
			detailsEditable: false,

			editable: {
				details: false,
				description: false,
				invoicenumbers: false,
			}
		};
	},

	created() {
		this.fetchJob();
		this.fetchJobTypes();
		this.fetchJobStates();
	},

	methods: {
		quoteCreate() {
			let newQuote = {
				JobId: this.job.Id,
				ContactId: null,
				Added: dateFuncs.today(),
				Introduction: '',
				Exclusions: '',
				Index: this.job.Quotes.length +1,  // push this for task ordering later.
				QuoteBlocks: [
					{
						Title: null,
						Cost: 0,
						QuoteLines: []
					}
				]
			};

			QuoteService.create(newQuote)
				.then((res) => {
					let jobId = res.data.JobId;
					let quoteId = res.data.Id;

					this.$router.push({
						name: 'quoteupdate',
						params: { id: jobId, quote: quoteId }
					});
				})

				.catch((error) => {
					this.handleError(error);
				});
		},

		quoteStatusName(id) {
			return this.quoteStates
				.filter((q) => q.Id == id)
				.map(function (obj) {
					return obj.Name;
				})
				.join();
		},

		mailStatusName(id) {
			return this.mailStates
				.filter((q) => q.Id == id)
				.map(function (obj) {
					return obj.Name;
				})
				.join();
		},

		editSection(section) {
			this.editable[section] = true;
		},

		saveSection(section) {
			this.updateJob(section);
		},

		removeFromArray(section, index, hold) {
			if (hold) {
				this.$refs.confirm.open('Confirm action', 'Are you sure you want to remove this item from ' + section).then((confirm) => {
					if (confirm) {
						this.removeFromArray(section, index);
					}
				});
			} else {
				this.$delete(this.contract[section], index);
				this.updateJob();
			}
		},

		fetchLogs() {
			LogService.get('Job', this.job.Id).then((response) => {
				this.logs = response.data;
			});
		},

		fetchJobTypes() {
			JobService.getEnum('jobtype')
				.then((response) => {
					this.jobTypes = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchJobStates() {
			JobService.getStates()
				.then((response) => {
					this.states = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchJob() {
			JobService.get(this.$router.currentRoute.params.id)
				.then((response) => {
					this.job = response.data;

					// make sure we can read the date
					let dueSqlDate = this.job.Due;
					this.job.Due = dateFuncs.frontEndDateFormat(dueSqlDate);

					// get logs
					this.fetchLogs();
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		changeContactClick() {
			// get clock contacts
			ContactService.getContacts(this.job.ClockId).then((res) => {
				this.contacts = res.data;
				this.modalContent = 'change-contact';
				this.modalTitle = 'Change Contact';
				this.$refs.sharedModal.show();
			});
		},

		changeContact(newContact) {
			this.job.Contact = newContact;
			this.job.ContactId = newContact.Id;

			this.$nextTick(() => {
				this.$refs.sharedModal.hide();
				this.modalContent = null;
				this.updateJob();
			});
		},

		editContact(contactId, index) {
			this.editing.id = contactId;
			this.editing.index = index;

			this.$nextTick(() => {
				this.modalContent = 'edit-contact';
				this.modalTitle = 'Edit Contact';
				this.$refs.sharedModal.show();
			});
		},

		updateContact(contactFromForm) {
			this.job.Contact.Name = contactFromForm.Name;
			this.job.Contact.Telephone = contactFromForm.Telephone;
			this.job.Contact.Mobile = contactFromForm.Mobile;
			this.job.Contact.Email = contactFromForm.Email;

			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		addNote() {
			this.fetchLogs();
			this.$nextTick(() => {
				this.modalContent = null;
				this.$refs.sharedModal.hide();
			});
		},

		deleteJob() {
			this.$refs.confirm.open('Delete', 'Are you sure you want to delete this job?').then((confirm) => {
				JobService.delete(this.job.Id)
					.then(() => {
						this.$refs.confirm.open('Success', 'Successfully deleted job', true).then((confirm) => {
							this.$router.push({ name: 'jobs' });
						});
					})
					.catch((error) => {
						this.handleError(error);
					});
			});
		},

		formatDate(date) {
			return dateFuncs.humanDateFormat(date);
		},

		updateJob(section) {
			JobService.update(this.job.Id, this.job)
				.then(() => {
					// only close editable sections on success
					if (section) this.editable[section] = false;

					this.fetchLogs();
				})
				.catch((error) => {
					this.handleError(error);
				});
		},

		updateTasks(tasks, save) {
			let assignmentsDTO = {
				Assignments: tasks
			};
			let vm = this;
			if (save) {
				JobService.updateAssignments(this.job.Id, assignmentsDTO)
					.then((res) => {
						vm.job.Assignments = tasks;
					})
					.catch((error) => {
						this.handleError(error);
					});
			} else {
				vm.job.Assignments = tasks;
			}
		},

		handleError(err) {
			let modal_options = {
				text: 'light',
				background: 'danger'
			};

			let message;

			if (err.response.data != '') {
				message = err.MessageDetail != null ? err.MessageDetail : err.ExceptionMessage;
			} else {
				switch (err.response.status) {
					case 404:
						message = err.response.status + ' - Could not find requested data';
						break;
					case 500:
						message = err.response.status + ' - There was a fatal error whilst processing this request';
						break;

					default:
						message = err.response.status + ' - There was an unknown error whilst processing this request';
				}
			}

			this.$refs.confirm.open('Error', message, true, modal_options);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/job/job-update.vue